module.exports = __webpack_public_path__ + "images/thumb-fe73da9cb6810455f6e3f37d5ef602cb.jpg";